/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Position_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose a caption position and apply it to selected events." |
*
* @param {Caption_Position_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_position_description = /** @type {((inputs?: Caption_Position_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Position_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez une position de sous-titrage et appliquez-la aux événements sélectionnés.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Bildunterschriftenposition und wenden Sie sie auf ausgewählte Ereignisse an.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli una posizione della didascalia e applicala agli eventi selezionati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите позицию подписи и примените её к выбранным событиям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elija una posición de subtítulo y aplíquela a los eventos seleccionados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择标题位置并将其应用于选定的活动。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション位置を選択し、選択したイベントに適用します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक कैप्शन स्थिति चुनें और इसे चयनित इवेंट्स पर लागू करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha uma posição da legenda e aplique-a aos eventos selecionados.")
	return /** @type {LocalizedString} */ ("Choose a caption position and apply it to selected events.")
});